import React from 'react'
import { PALETTE } from '../../styles/constants'

function LaunchIcon({ color = PALETTE.gray80 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_3219_4256)">
        <path d="M26 28H6C5.46979 27.9993 4.96149 27.7883 4.58658 27.4134C4.21166 27.0385 4.00071 26.5302 4 26V6C4.00071 5.46979 4.21166 4.96149 4.58658 4.58658C4.96149 4.21166 5.46979 4.00071 6 4H16V6H6V26H26V16H28V26C27.9993 26.5302 27.7883 27.0385 27.4134 27.4134C27.0385 27.7883 26.5302 27.9993 26 28Z" fill={color}/>
        <path d="M20 2V4H26.586L18 12.586L19.414 14L28 5.414V12H30V2H20Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_3219_4256">
          <rect width="32" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default LaunchIcon


